import './example.css'
import React from 'react'
import TitleSection from '../TitleSection/TitleSection'
import img2 from '../img/macbook-cover.svg';
import img3 from '../img/macbook-bottom.svg';
import e1 from '../img/e1.png'
import e2 from '../img/e2.png'
import e3 from '../img/e3.png'
import e4 from '../img/e4.png'
import e5 from '../img/e5.png'
import e6 from '../img/e6.png'
import e7 from '../img/e7.png'
import e8 from '../img/e8.png'
import e9 from '../img/e9.png'
import e10 from '../img/e10.png'
import MobileExample from '../MobileExample/MobileExample';
import Texample from '../Texamole/Texample';








import Carousel, { consts } from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faLeftLong , faRightLong } from '@fortawesome/free-solid-svg-icons';

function Example1() {
  const row1 = [
    {
      id: 1,
      img: e1,
      title: "منصة سلة",
      link: "https://salla.com/"
    },
    {
      id: 2,
      img: e2,
      title: "منصة زد",
      link: "https://zid.sa/ar"
    },
    {
      id: 3,
      img: e3,
      title: "سطحة",
      link: "https://www.nsamatalhsi.com.sa/"
    },
    {
      id: 4,
      img: e4,
      title: "دكتور كار لصيانة السيارات",
      link: "https://dr-car.netlify.app/"
    },
    {
      id: 5,
      img: e5,
      title: "alahli.com",
      link: "https://www.alahli.com/ar/pages/personal-banking/digital-banking/online-banking"
    },
    {
      id: 6,
      img: e6,
      title: "alrajhibank",
      link: "https://www.alrajhibank.com.sa/"
    },
    {
      id: 7,
      img: e7,
      title: "petromin",
      link: "https://petromin.express/"
    },
    {
      id: 8,
      img: e8,
      title: "PIF",
      link: "https://www.pif.gov.sa/ar/"
    },
    {
      id: 9,
      img: e9,
      title: "الأهلي الملكي المرنقي",
      link: "https://www.alahlifc.sa/"
    },
    {
      id: 10,
      img: e10,
      title: "huawei",
      link: "https://consumer.huawei.com/sa/"
    }
  ]

  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 3
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 2
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const CustomButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
      <div className="custom-button-group">
        <button onClick={() => previous()} className="custom-arrow left">
        <FontAwesomeIcon icon={faRightLong} className='exampleicon'/>
         </button>
        <button onClick={() => next()} className="custom-arrow right">
        <FontAwesomeIcon icon={faLeftLong} className='exampleicon'/>
          </button>
      </div>
    );
  };

  return (
   <>
    <div className='example' id='exampleid'>
      <div className="container">
        <TitleSection title="أمثلة على المواقع الإلكترونية"/>
        <Carousel 
          responsive={responsive} 
          autoPlay={true}
          autoPlaySpeed={5000}
          infinite={true}
          customButtonGroup={<CustomButtonGroup />}
          renderButtonGroupOutside={true}
          arrows={false}
          className='m--20'
        >
          {row1.map((item, index) => (
            <div key={index} className="mockup mockup-macbook m-4">
              <div className="part bottom">
                <div className="cover-container">
                  <img src={img2} alt="Mac" className="img-fluid cover" />
                  <a href={item.link} target='_blank' rel="noopener noreferrer">
                    <img src={item.img} alt={item.title} className='imgexample' />
                  </a>
                </div>
                <img src={img3} alt="" className="img-fluid bottom mt-1" />
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
    <MobileExample />
    <Texample />
   </>
  )
}

export default Example1
